import { useAuth } from '@restworld/feature-authentication';
export function useIsFreemiumUser() {
  var _useAuth = useAuth(),
      user = _useAuth.user; // With new PPU (Pay-Per-Use) business model, users are NEVER freemium


  if (user !== null && user !== void 0 && user.using_ppu_business_model) {
    return false;
  } // Legacy logic for old business model


  return !!(user !== null && user !== void 0 && user.freemium_user);
}